import { all, call } from 'redux-saga/effects';
/***** LOGIN *****/
import { loginSaga } from './login/login.saga';
/***** LOGIN *****/

import { profileSaga } from './profile/profile.saga';
import { generalSaga } from './general/general.saga';
import { dashboardSaga } from './dashboard/dashboard.saga';
import { verificationSaga } from './verification/verification.saga';

/**** User Control Access *****/
import { assignUserRightsMasterSaga } from './user-controls-access/assign-users-rights/assign-users-rights.saga';
import { memberMandatoryAccessMasterSaga } from './user-controls-access/member-mandatory-access/member-mandatory-access.saga';

/***** MASTERS *****/
import { branchMasterSaga } from './master/branch/branch.saga';
import { centerMasterSaga } from './master/center/center.saga';
import { staffMasterSaga } from './master/staff/staff.saga';
import { roleMasterSaga } from './master/role/role.saga';
import { savingsMasterSaga } from './master/savings/savings.saga';
import { insuranceCompanySaga } from './master/insurance-company/insurance-company.saga';
import { purposeofLoanTypeSaga } from './master/purpose-of-loan-type/purpose-of-loan-type.saga';
import { productTypeMasterSaga } from './master/product-type/product-type.saga';
import { businessfundMasterSaga } from './master/business-fund/business-fund.saga';
import { funderMasterSaga } from './master/funder/funder.saga';
import { groupMasterSaga } from './master/group/group.saga';
import { economicActivityMasterSaga } from './master/economicActivity/economicActivity.saga';
import { economicActivityTypeMasterSaga } from './master/economic-activity-type/economic-activity-type.saga';
import { productMasterSaga } from './master/product/product.saga';
import { questionnaireSaga } from './master/questionaire/questionaire.saga';

// COMPANY
import { companySaga } from './company/company.saga';

// MASTERS - MEMBER
import { memberMasterSaga } from './master/member/member.saga';
import { verifyOtpSaga } from './master/member-add/verify-otp/verify-otp.saga';
import { aadharDetailsSaga } from './master/member-add/aadhar-details/aadhar-details.saga';
import { memberDetailsSaga } from './master/member-add/add-member/add-member.saga';
import { basicDetailsSaga } from './master/member-add/basic-details/basic-details.saga';
import { addMemberPhotoSaga } from './master/member-add/photo-verification/photo-verification.saga';
import { signatureSaga } from './master/member-add/signature/signature.saga';
import { personalDetailsSaga } from './master/member-add/personal-details/personal-details.saga';
import { familyDetailSaga } from './master/member-add/family-details/family-details.saga';
import { nomineeDetailsSaga } from './master/member-add/basic-nominee-details/basic-nominee-details.saga';
import { memberBankDetailsSaga } from './master/member-add/bank-details/bank-details.saga';
import { houseDetailsSaga } from './master/member-add/house-details/house-details.saga';
import { drivingLicenceSaga } from './master/member-add/driving-licence-details/driving-licence-details.saga';
import { pancardDetailsSaga } from './master/member-add/pancard-details/pancard-details.saga';
import { passportSaga } from './master/member-add/passport-details/passport-details.saga';
import { rationCardDetailsSaga } from './master/member-add/ration-card-details/ration-card-details.saga';
import { voterIdDetailsSaga } from './master/member-add/voter-id-details/voter-id-details.saga';
import { addressExtraProofSaga } from './master/member-add/address-extra-proof/address-extra-proof.saga';
import { passbookChequeDetailsSaga } from './master/member-add/passbook-cheque-details/passbook-cheque-details.saga';
import { housePhotosSaga } from './master/member-add/house-photos/house-photos.saga';
import { extraInformationSaga } from './master/member-add/extra-infromation/extra-information.saga';
import { officialDetailsSaga } from './master/member-add/official-details/official-details.saga';
import { nocPhotosSaga } from './master/member-add/noc-photos/noc-photos.saga';
import { currentAddressSaga } from './master/member-add/current-address/current-address.saga';
import { coApplicantSaga } from './master/member-add/co-applicant/co-applicant.saga';
import { creditCheckDetailsSaga } from './master/member-add/credit-check/credit-check.saga';
import { residentialDetailsSaga } from './master/member-add/residential-details/residential-details.saga';
import { advanceMemberSaga } from './master/member-add/advance-member/advance-member.saga';

/***** MASTERS *****/

/*****OPERATIONS *****/
import { reportAuditingToolSaga } from './operations/auditing-tool/auditing-tool.saga';
import { commonTransferLogSaga } from './operations/common-transfer-log/common-transfer-log.saga';
import { transferCenterSaga } from './operations/transfer-center/transfer-center.saga';
import { transferBranchSaga } from './operations/transfer-branch/transfer-branch.saga';
import { transferFunderSaga } from './operations/transfer-funder/transfer-funder.saga';
import { changeMeetingDateSaga } from './operations/change-meeting-date/change-meeting-date.saga';
import { changeGroupOfficerSaga } from './operations/change-group-officer/change-group-officer.saga';
import { enachUploadDetailsSaga } from './operations/nach-umrn-link/nach-umrn-link.sage';
import { LastEMIDetailsSaga } from './operations/last-emi-details/last-emi-details.saga';

/*****OPERATIONS - LOAN PROPOSAL *****/
import { centerWiseLoanProposalSaga } from './operations/loan-proposal/center-wise-loan-proposal/center-wise-loan-proposal.saga';
import { commonLoanPrposalSaga } from './operations/loan-proposal/common-loan-proposal/common-loan-proposal.saga';

import { rangeLoanProposalSaga } from './operations/loan-proposal/range-product-loan-proposal/range-product-loan-proposal.saga';
import { groupWiseLoanProposalSaga } from './operations/loan-proposal/group-wise-loan-proposal/group-wise-loan-proposal.saga';
import { customproductLoanProposalSaga } from './operations/loan-proposal/custom-product-loan-proposal/custom-product-loan-proposal.saga';
import { individualLoanProposalSaga } from './operations/loan-proposal/individual-loan-proposal/individual-loan-proposal.saga';
import { productLoanProposalSaga } from './operations/loan-proposal/product-loan-proposal/product-loan-proposal.saga';
import { businessLoanProposalSaga } from './operations/loan-proposal/business-loan-proposal/business-loan-proposal.saga';
import { recurringDepositProposalSaga } from './operations/loan-proposal/recurring-deposit-proposal/recurring-deposit-proposal.saga';

/*****OPERATIONS - COLLECTION *****/
import { collectionApprovalSaga } from './operations/collection/collection-approve/collection-approve.saga';
import { demandCollectionSaga } from './operations/collection/demand-collection/demand-collection.saga';
import { advanceCollectionSaga } from './operations/collection/advance-collection/advance-collection.saga';
import { arrearCollectionSaga } from './operations/collection/arrear-Collection/arrear-Collection.saga';
import { goldCollectionSaga } from './operations/collection/gold-loan-collection/gold-loan-collection.saga';
import { memberCollectionSaga } from './operations/collection/member-collection/member-collection.saga';
import { preCloseLoanMemberSaga } from './operations/pre-close-loan/pre-close-loan.saga';
import { GoldCloseLoanSaga } from './operations/gold-close-loan/gold-close-loan.saga';
import { savingCollectionSaga } from './operations/collection/saving-collection/saving-collection.saga';
import { fixedDepositSaga } from './operations/collection/fixed-deposit/fixed-deposit.saga';

/***** OPERATIONS- LOAN DISBURSEMENT *****/
import { loanIndexDisbursementSaga } from './operations/loan-disbursement/loan-index-disbursement/loan-index-disbursement.saga';
import { goldLoanDisbursementSaga } from './operations/loan-disbursement/gold-loan-disbursement/gold-loan-disbursement.saga';
/*****REPORTS *****/
import { reportLoanDisbursementSaga } from './reports/loan-disbursement/loan-disbursement.saga';
import { groupOfficerReportSaga } from './reports/group-officer-report/group-officer-report.saga';
import { requestReportSaga } from './reports/request-report/request-report.saga';
import { reportDemandCollectionSaga } from './reports/demand-collection-report/demand-collection-report.saga';
import { futureDemandReportSaga } from './reports/future-demand-report/future-demand-report.saga';
import { memberDetailsReportSaga } from './reports/member-details-report/member-details-report.saga';
import { portfolioAtRiskReportSaga } from './reports/portfolio-at-risk-report/portfolio-at-risk-report.saga';
import { portfolioAtRiskReportSaga as portfolioReportSaga } from './reports/portfolio-report/portfolio-report.saga';
import { branchProfileReportSaga } from './reports/branch-profile-report/branch-profile-report.saga';
import { loanCardReportSaga } from './reports/loan-card-report/loan-card-report.saga';
import { arrearFollowupReportSaga } from './reports/arrear-followup-report/arrear-followup-report.saga';
import { dailyCollectionReportSaga } from './reports/daily-collection-report/daily-collection-report.saga';
import { branchCollectionReportSaga } from './reports/branch-collection-report/branch-collection-report.saga';
import { walletReportSaga } from './reports/wallet-report/wallet-report.saga';
import { thriftReportSaga } from './reports/thrift-report/thrift-report.saga';
import { reportDeadMemberSaga } from './reports/dead-member-report/dead-member-report.saga';
import { reportPrecloseSaga } from './reports/preclose-loan-report/preclose-loan-report.saga';
import { branchDCBReportSaga } from './reports/branch-DCB-report/branch-DCB-report.saga';
import { reportDemandFollowupSaga } from './reports/demand-followup-report/demand-followup-report.saga';
import { reportClosedLoanSaga } from './reports/closed-loan-report/closed-loan-report.saga';
import { reportActiveMemberSaga } from './reports/active-member-report/active-member.saga';
import { reportChangeMeetingSaga } from './reports/change-meeting-report/change-meeting-report.saga';
import { insuranceReportSaga } from './reports/insurance-report/insurance-report.saga';
import { EndOfDaySaga } from './operations/end-of-day/end-of-day.saga';
import { accountDayBookReportSaga } from './reports/day-book-report/day-book-report.saga';
import { overDueReportSaga } from './reports/over-due-report/over-due-report.saga';
import { reportInActiveMemberSaga } from './reports/in-active-member-report/in-active-member.saga';
import { enachReportSaga } from './reports/enach-report/enachReport.saga';
import { mandateReportSaga } from './reports/mandate-report/MandateReport.saga';
import { qrReportSaga } from './reports/qr-report/qr-report.saga';
import { groupReportSaga } from './reports/group-report/group.report.saga';
import { memberRejectionReportSaga } from './reports/member-rejection-report/member-rejection-report.saga';
import { attendanceReportSaga } from './reports/attendance-report/attendance-report.saga';
import { sanctionReportSaga } from './reports/sanction-report/sanction-report.saga';
import { StaffReportSaga } from './reports/staff-report/staff-report.saga';
import { centerDCBReportSaga } from './reports/center-DCB-report/center-DCB-report.saga';
import { collectionFormatReportSaga } from './reports/collection-format-report/collection-format-report.saga';
import { BranchSummaryReportSaga } from './reports/branch-summary-report/branch-summary-report.saga';
// import { VehicleSeizedReportSaga } from './reports/vehicle-seized-report/vehicle-seized-report.saga';
import { dealerReportSaga } from './reports/dealer-report/dealer-report.saga';
/******** Temproary Command this - prabananth ********/
import { auditTrailReportSaga } from './reports/unusedReportRedux/audit-trail-report/audit-trail-report.saga';

import { auditingToolReportSaga } from './reports/auditing-tool-report/auditing-tool-report.saga';
import { kycSourcedReportSaga } from './reports/kyc-sourced-report/kyc-sourced-report.saga';
import { memberAccountReportSaga } from './reports/member-account-report/member-account-report.saga';
import { postAuditingToolReportSaga } from './reports/post-auditing-tool-report/post-auditing-tool-report.saga';
import { NPAReportSaga } from './reports/npa-report/npa-report.saga';
import { memberAttendanceReportSaga } from './reports/member-attendance-report/member-attendance-report.saga';
import { repaymentCollectionReportSaga } from './reports/repayment-collection-report/repayment-collection-report.saga';
import { progressReportSaga } from './reports/progress-report/progress-report.saga';
import { promiseToPayReportSaga } from './reports/promise-to-pay-report/promise-to-pay-report.saga';
import { monthWiseInterestSummaryReportSaga } from './reports/month-wise-interest-summary-report/month-wise-interest-summary-report.saga';

/*****FINANCE - MASTER *****/
import { gstTypeFinanceSaga } from './finance/master/gstType/gstType.saga';
import { accountSaga } from './finance/master/account/account.saga';
import { CloseLoanMemberSaga } from './operations/close-loan/close-loan.saga';
import { goldLoanProposalSaga } from './operations/loan-proposal/gold-loan-proposal/gold-loan-proposal.saga';
import { monthlyProgressSaga } from './reports/monthly-progress-report/monthly-progress.saga';
import { goldPriceReportSaga } from './reports/gold-price-report/gold-price-report.saga';
import { GoldLoanInterestReminderReportSaga } from './reports/gold-loan-interest-reminder-report/gold-loan-interest-reminder-report.saga';
import { reportGoldLoanCollectionSaga } from './reports/gold-loan-collection-report/gold-loan-collection-report.saga';
import { GoldLoanarrearPriceReportSaga } from './reports/gold-loan-arrear-report/gold-loan-arrear-report.saga';
import { accountMapDetailsSaga } from './finance/master/account-mapping/account-mapping.saga';
import { journalTransactionDetailsSaga } from './finance/master/journal-transaction/journal-transaction.saga';
import { groupAccountFinanceSaga } from './finance/master/groupAccount/groupAccount.saga';
import { subGroupAccountSaga } from './finance/master/subGroupAccount/subGroupAccount.saga';
import { openingbalanceFinanceSaga } from './finance/master/opening-balance/opening-balance.saga';
import { ProfitAndLossFinanceSaga } from './finance/reports/profitAndLossReport/profit-and-loss.saga';
import { instrumentSaga } from './finance/master/instrument/instrument.saga';

// Transaction
import CashTransactionSaga from './finance/transaction/common-transaction.saga';

/*****FINANCE - REPORTS *****/
import { ledgerReportsSaga } from './finance/reports/ledgerReports/LedgerReports.saga';
import { receiptsPaymentsSaga } from './finance/reports/receiptsPayments/ReceiptsPayments.saga';

/***** AUTO LOAN *****/
import { dealerMasterSaga } from './master/dealer/dealer.saga';
import { autoLoanCollectionSaga } from './operations/collection/auto-loan-collection/auto-loan-collection.saga';
import { autoLoanProposalSaga } from './operations/loan-proposal/auto-loan-proposal/auto-loan-proposal.saga';
import { autoLoanIndexDisbursementSaga } from './operations/loan-disbursement/auto-loan-index-disbursement/auto-loan-index-disbursement.saga';
import { bankTransactionSaga } from './finance/master/bankTransaction/bankTransaction.saga';
import { balanceSheetSaga } from './finance/reports/balance-sheet/balance-sheet.saga';
import { daybookReportSaga } from './finance/reports/dayBookReports/daybookReport.saga';
import { fieldOfficerLocationSaga } from './reports/officer-location/officer-location-report.saga';
import { TrailBalanceFinanceSaga } from './finance/reports/trailBalance/trailBalance.saga';
import { funderDetailsSaga } from './operations/Funder-Details/funder-details.saga';
import { purposeofLoanSaga } from './master/purpose-of-loan/purpose-of-loan.saga';
import { autoLoanCollectionReportSaga } from './reports/auto-loan-collection-report/auto-loan-collection-report.saga';
import { businessDetailsSaga } from './master/business/business-details/business-details.saga';
import { branchDetailsSaga } from './master/business/branch-details/branch-details.saga';
import { kYCVerificationSaga } from './master/business/kyc-verification/kyc-verification.saga';
import { proofDetailsSaga } from './master/business/proof-details/proof-details.saga';
import { partnerDetailsSaga } from './master/business/partner-details/partner-details.saga';
import { verificationDetailsSaga } from './master/business/verification-details/verification-details.saga';
import { partiesDetailsSaga } from './master/business/related-parties/related-parties.saga';
import { businessLoanDisbursementSaga } from './operations/loan-disbursement/business-loan-disbursement/business-loan-disbursement.saga';
import { bankDetailsSaga } from './master/business/bank-details/bank-details.saga';
import { closeLoanAdvanceSaga } from './operations/close-loan-advance/close-loan-advance.saga';
import { highmarkRulesSaga } from './user-controls-access/high-mark-rules/high-mark-rules.saga';
import { workflowManagementSaga } from './user-controls-access/work-flow-management/work-flow-management.saga';
import { goldStockSaga } from './reports/gold-stock-report/gold-stock-report.saga';
import { reportCreditBureauSaga } from './reports/credit-bureau-report/credit-bureau-report.saga';
import { reportDataVerificationSaga } from './reports/data-verification-report/data-verification-report.saga';
import { AccuredInterestReportSaga } from './reports/accured-interest-report/accured-interest-report.saga';
import { savingsFollowupReportSaga } from './reports/savings-followup-report/savings-followup.saga';
import { businessCollectionSaga } from './operations/collection/business-loan-collection/business-collection.saga';
import { centerWiseReportSaga } from './reports/center-wise-report/center-wise-report.saga';

export default function* rootSaga() {
	yield all([
		call(loginSaga),
		call(profileSaga),
		call(generalSaga),
		call(verificationSaga),

		// DASHBOARD
		call(dashboardSaga),

		// User Control Access
		call(assignUserRightsMasterSaga),
		call(memberMandatoryAccessMasterSaga),
		call(highmarkRulesSaga),
		call(workflowManagementSaga),

		// COMPANY
		call(companySaga),

		// MASTERS
		call(branchMasterSaga),
		call(centerMasterSaga),
		call(staffMasterSaga),
		call(roleMasterSaga),
		call(savingsMasterSaga),
		call(insuranceCompanySaga),
		call(purposeofLoanSaga),
		call(purposeofLoanTypeSaga),
		call(productTypeMasterSaga),
		call(businessfundMasterSaga),
		call(funderMasterSaga),
		call(groupMasterSaga),
		call(economicActivityMasterSaga),
		call(economicActivityTypeMasterSaga),
		call(memberMasterSaga),
		call(verifyOtpSaga),
		call(basicDetailsSaga),
		call(addMemberPhotoSaga),
		call(signatureSaga),
		call(personalDetailsSaga),
		call(familyDetailSaga),
		call(nomineeDetailsSaga),
		call(memberBankDetailsSaga),
		call(houseDetailsSaga),
		call(aadharDetailsSaga),
		call(drivingLicenceSaga),
		call(pancardDetailsSaga),
		call(passportSaga),
		call(rationCardDetailsSaga),
		call(voterIdDetailsSaga),
		call(addressExtraProofSaga),
		call(passbookChequeDetailsSaga),
		call(housePhotosSaga),
		call(extraInformationSaga),
		call(officialDetailsSaga),
		call(nocPhotosSaga),
		call(currentAddressSaga),
		call(residentialDetailsSaga),
		call(coApplicantSaga),
		call(creditCheckDetailsSaga),
		call(memberDetailsSaga),
		call(advanceMemberSaga),
		call(productMasterSaga),
		call(questionnaireSaga),
		call(businessDetailsSaga),
		call(bankDetailsSaga),
		call(branchDetailsSaga),
		call(kYCVerificationSaga),
		call(partnerDetailsSaga),
		call(proofDetailsSaga),
		call(partiesDetailsSaga),
		call(verificationDetailsSaga),

		// Operations
		call(reportAuditingToolSaga),
		call(funderDetailsSaga),
		call(CloseLoanMemberSaga),
		call(preCloseLoanMemberSaga),
		call(GoldCloseLoanSaga),
		call(commonTransferLogSaga),
		call(transferCenterSaga),
		call(changeMeetingDateSaga),
		call(changeGroupOfficerSaga),
		call(transferBranchSaga),
		call(transferFunderSaga),
		call(enachUploadDetailsSaga),
		call(closeLoanAdvanceSaga),
		call(LastEMIDetailsSaga),

		// Operations - Loan Proposal
		call(centerWiseLoanProposalSaga),
		call(commonLoanPrposalSaga),
		call(rangeLoanProposalSaga),
		call(groupWiseLoanProposalSaga),
		call(customproductLoanProposalSaga),
		call(individualLoanProposalSaga),
		call(productLoanProposalSaga),
		call(goldLoanProposalSaga),
		call(EndOfDaySaga),
		call(accountDayBookReportSaga),
		call(businessLoanProposalSaga),
		call(recurringDepositProposalSaga),

		// OPERATION - COLLECTION
		call(collectionApprovalSaga),
		call(demandCollectionSaga),
		call(advanceCollectionSaga),
		call(arrearCollectionSaga),
		call(goldCollectionSaga),
		call(memberCollectionSaga),
		call(savingCollectionSaga),
		call(fixedDepositSaga),
		call(businessCollectionSaga),

		// LOAN DISBURSEMENT
		call(loanIndexDisbursementSaga),
		call(businessLoanDisbursementSaga),
		call(goldLoanDisbursementSaga),

		//REPORTS
		call(goldStockSaga),
		call(reportLoanDisbursementSaga),
		call(requestReportSaga),
		call(reportDemandCollectionSaga),
		call(futureDemandReportSaga),
		call(memberDetailsReportSaga),
		call(overDueReportSaga),
		call(portfolioAtRiskReportSaga),
		call(portfolioReportSaga),
		call(arrearFollowupReportSaga),
		call(loanCardReportSaga),
		call(branchProfileReportSaga),
		call(dailyCollectionReportSaga),
		call(branchDCBReportSaga),
		call(reportDemandFollowupSaga),
		call(branchCollectionReportSaga),
		call(walletReportSaga),
		call(thriftReportSaga),
		call(reportClosedLoanSaga),
		call(reportDeadMemberSaga),
		call(reportPrecloseSaga),
		call(reportActiveMemberSaga),
		call(reportChangeMeetingSaga),
		call(reportInActiveMemberSaga),
		call(qrReportSaga),
		call(groupReportSaga),
		call(memberRejectionReportSaga),
		call(attendanceReportSaga),
		call(sanctionReportSaga),
		call(StaffReportSaga),
		call(fieldOfficerLocationSaga),
		call(autoLoanCollectionReportSaga),
		call(savingsFollowupReportSaga),
		call(auditTrailReportSaga),
		call(monthlyProgressSaga),
		call(auditingToolReportSaga),
		call(kycSourcedReportSaga),
		call(memberAccountReportSaga),
		call(postAuditingToolReportSaga),
		call(GoldLoanarrearPriceReportSaga),
		call(reportGoldLoanCollectionSaga),
		call(GoldLoanInterestReminderReportSaga),
		call(goldPriceReportSaga),
		call(NPAReportSaga),
		call(memberAttendanceReportSaga),
		call(insuranceReportSaga),
		call(enachReportSaga),
		call(mandateReportSaga),
		call(repaymentCollectionReportSaga),
		call(progressReportSaga),
		call(promiseToPayReportSaga),
		call(groupOfficerReportSaga),
		call(monthWiseInterestSummaryReportSaga),
		call(accountSaga),
		call(centerDCBReportSaga),
		call(reportCreditBureauSaga),
		call(reportDataVerificationSaga),
		call(AccuredInterestReportSaga),
		call(collectionFormatReportSaga),
		call(BranchSummaryReportSaga),
		// call(VehicleSeizedReportSaga),
		call(dealerReportSaga),
		call(centerWiseReportSaga),

		//FINANCE - MASTER
		call(gstTypeFinanceSaga),
		call(openingbalanceFinanceSaga),
		call(accountMapDetailsSaga),
		call(journalTransactionDetailsSaga),
		call(groupAccountFinanceSaga),
		call(subGroupAccountSaga),
		call(instrumentSaga),
		call(bankTransactionSaga),

		// Transaction
		call(CashTransactionSaga),

		//FINANCE - REPORTS
		call(ledgerReportsSaga),
		call(ProfitAndLossFinanceSaga),
		call(receiptsPaymentsSaga),
		call(balanceSheetSaga),
		call(daybookReportSaga),
		call(TrailBalanceFinanceSaga),

		// AUTO LOAN
		call(autoLoanCollectionSaga),
		call(dealerMasterSaga),
		call(autoLoanProposalSaga),
		call(autoLoanIndexDisbursementSaga),
	]);
}
